import HeaderLogo from '@/assets/logo_twm.png'
import PDFDivider from '@/components/ReportPDF/PDFDivider'
import { DATE_FORMAT_CN } from '@/libs/core/constants'
import { Image, Page, Text, View } from '@react-pdf/renderer'
import moment from 'moment'
import styles from '@/components/ReportPDF/styles'

const CoverPage = ({ reportData }) => {
  const { reportDate, firstPartyFullName } = reportData || {}

  return (
    <Page
      dpi={150}
      size="A4"
      style={{ display: 'flex', fontFamily: 'Noto Sans', padding: '20px 10px 10px 10px' }}
    >
      <Image src={HeaderLogo} style={{ margin: 100 }} />
      <View style={{ fontSize: 30, alignItems: 'center', marginHorizontal: 40, marginTop: 40 }}>
        <Text>{'資安教育訓練服務'}</Text>
        <Text>{'結果及分析報告書'}</Text>
        <PDFDivider style={{ marginVertical: 20 }} />
        <Text style={styles.primaryText}>{firstPartyFullName}</Text>
        <Text style={[styles.primaryText, { fontSize: 16, marginTop: 40 }]}>
          {moment(reportDate).format(DATE_FORMAT_CN)}
        </Text>
      </View>
    </Page>
  )
}

export default CoverPage
